import { RouteRecordRaw } from 'vue-router';

import AccountDetail from '@/components/pages/user/AccountDetail.vue';
import Analytics from '@/components/pages/user/Analytics.vue';
import Beta from '@/components/pages/user/Beta.vue';
import CallAnalytics from '@/components/pages/user/CallAnalytics.vue';
import Cockpit from '@/components/pages/user/Cockpit.vue';
import User from '@/components/pages/user/Index.vue';
import LeadList from '@/components/pages/user/LeadList.vue';
import Mail from '@/components/pages/user/Mail.vue';
import MailTemplate from '@/components/pages/user/MailTemplate.vue';
import RlsCheck from '@/components/pages/user/RlsCheck.vue';
import Sequence from '@/components/pages/user/Sequence.vue';
import SequenceLeads from '@/components/pages/user/SequenceLeads.vue';
import SequenceNew from '@/components/pages/user/SequenceNew.vue';
import Sequences from '@/components/pages/user/Sequences.vue';
import Setting from '@/components/pages/user/Setting.vue';
import SisenseSSO from '@/components/pages/user/SisenseSSO.vue';
import Training from '@/components/pages/user/Training.vue';
import Transcription from '@/components/pages/user/Transcription.vue';
import Trigger from '@/components/pages/user/Trigger.vue';
import TriggerLeads from '@/components/pages/user/TriggerLeads.vue';
import Triggers from '@/components/pages/user/Triggers.vue';
import { i18nGlobal as i18n } from '@/i18n';

export const userRoutes: RouteRecordRaw[] = [
  {
    path: '/app',
    component: User,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'lead-list',
        name: 'LeadList',
        component: LeadList,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('leadList.title'),
        },
      },
      {
        path: 'mail',
        name: 'Mail',
        component: Mail,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('mail.title'),
        },
      },
      {
        path: 'mail-template',
        name: 'MailTemplate',
        component: MailTemplate,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('mailTemplate.title'),
        },
      },
      {
        path: 'call-analytics',
        name: 'CallAnalytics',
        component: CallAnalytics,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('callAnalytics.title'),
        },
      },
      {
        path: 'analytics',
        name: 'Analytics',
        component: Analytics,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('analytics.title'),
        },
      },
      {
        path: 'beta',
        name: 'Beta',
        component: Beta,
        meta: {
          rule: 'isCrmUser',
        },
      },
      {
        path: 'cockpit',
        name: 'Cockpit',
        component: Cockpit,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('cockpit.title'),
        },
      },
      {
        path: '/app/sisense/sso',
        name: 'SisenseSSO',
        component: SisenseSSO,
        meta: {
          rule: 'isCrmUser',
        },
      },
      {
        path: 'rls-check',
        name: 'rls-check',
        component: RlsCheck,
        meta: {
          rule: 'isCrmUser',
        },
      },
      {
        path: '/app:pathMatch(.*)*',
        redirect: { name: 'Cockpit' },
        meta: {
          rule: 'isCrmUser',
        },
      },
      {
        path: '/app',
        redirect: { name: 'Cockpit' },
        meta: {
          rule: 'isCrmUser',
        },
      },
      {
        path: 'setting/:tab?/:subTab?',
        name: 'Setting',
        component: Setting,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('corpSetting.title'),
        },
      },
      {
        path: 'sequences',
        name: 'Sequences',
        component: Sequences,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('sequence.title'),
        },
      },
      {
        path: 'sequences/:id',
        name: 'Sequence',
        component: Sequence,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('sequence.title'),
        },
      },
      {
        path: 'sequences/new',
        name: 'SequenceNew',
        component: SequenceNew,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('sequence.title'),
        },
      },
      {
        path: 'sequences/:id/leads',
        name: 'SequenceLeads',
        component: SequenceLeads,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('sequence.title'),
        },
      },
      {
        path: 'triggers',
        name: 'Triggers',
        component: Triggers,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('trigger.title'),
        },
      },
      {
        path: 'triggers/new',
        name: 'TriggerNew',
        component: Trigger,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('trigger.title'),
        },
      },
      {
        path: 'triggers/:id(\\d+)',
        name: 'Trigger',
        component: Trigger,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('trigger.title'),
        },
      },
      {
        path: 'triggers/:id/leads',
        name: 'TriggerLeads',
        component: TriggerLeads,
        meta: {
          rule: 'isCrmUser',
          title: i18n.t('trigger.title'),
        },
      },
      {
        path: '/app/training',
        name: 'Training',
        component: Training,
        meta: {
          rule: 'isCrmOwnerMember',
          title: 'トレーニング',
        },
      },
    ],
  },
  {
    path: '/app/call-results/:callResultId/transcription',
    name: 'Transcription',
    component: Transcription,
    meta: {
      requiresAuth: true,
      rule: 'isCrmUser',
      title: i18n.t('transcription.title'),
    },
  },
  {
    path: '/app/accounts/:key',
    name: 'AccountDetail',
    component: AccountDetail,
    meta: {
      rule: 'isCrmUser',
      title: 'アカウント詳細',
    },
  },
];
